import {getCSRF_Token} from "@/fonction/logConnection";
// import fournisseurMock from "@/mock/getFournisseur.json";
import fournisseursMock from "@/mock/getFournisseurs.json";
import {Contrat} from "@/ts/contrat";
// import fournisseurUserTableauBordMock from "@/mock/getFournisseurUserDashboard.json";
import {
  FournisseurAndCampagne,
  FournisseurSearch,
  FournisseurUserTableauBord,
} from "@/ts/fournisseur";
import {FournisseurBonus} from "@/ts/kpi";
import {Pagination} from "@/ts/pagination";

import {
  callApi,
  //  getDataMock
} from "./_callApi";

export async function getFournisseurs(
  API: string | undefined,
  params: Record<string, any> = {hitsPerPage: "5000"},
  currentContremarque?: string
): Promise<{
  pagination: Pagination;
  fournisseurs: FournisseurSearch[];
}> {
  try {
    if (
      // getDataMock()
      false
    ) {
      return fournisseursMock;
    } else {
      if (!API) {
        throw new Error("API is not provided.");
      }
      // Construction dynamique de l'URL avec les paramètres
      const url = new URL(`${API}/api/coact/v1/fournisseurs`);

      // Ajout automatique de tous les paramètres à l'URL
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          url.searchParams.append(key, String(value));
        }
      });
      const {pagination, results} = await callApi(
        url.toString(),
        "GET",
        {
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRF_Token(),
          ...(currentContremarque
            ? {"X-Coact-Contremarque": currentContremarque}
            : {}),
        },
        "include"
      );
      return {
        pagination,
        fournisseurs: results,
      };
    }
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function addFournisseur(
  API: string | undefined,
  body: {fournisseur_id: number; bonus: FournisseurBonus[]},
  idCampagne: number
): Promise<void> {
  try {
    if (!API) {
      throw new Error("API is not provided.");
    }
    await callApi(
      `${API}/api/coact/v1/campagnes/${idCampagne}/fournisseurs`,
      "POST",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include",
      body
    );
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function removeFournisseur(
  API: string | undefined,
  idFournisseur: number,
  idCampagne: number
): Promise<void> {
  try {
    if (!API) {
      throw new Error("API is not provided.");
    }
    await callApi(
      `${API}/api/coact/v1/campagnes/${idCampagne}/fournisseurs/${idFournisseur}`,
      "DELETE",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include",
      {},
      false
    );
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function getFournisseur(
  API: string | undefined,
  idFournisseur: number,
  campagneId: number,
  currentContremarque?: string
): Promise<FournisseurAndCampagne> {
  try {
    if (
      // getDataMock()
      false
    ) {
      // return fournisseurMock as FournisseurAndCampagne;
    } else if (!API) {
      throw new Error("API is not provided.");
    }
    const reponse = await callApi(
      `${API}/api/coact/v1/fournisseurs/${idFournisseur}?campagne_id=${campagneId}`,
      "GET",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
        ...(currentContremarque
          ? {"X-Coact-Contremarque": currentContremarque}
          : {}),
      },
      "include"
    );
    return reponse;
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function getFournisseurTableauBord(
  API: string | undefined,
  campagneId?: number
): Promise<FournisseurUserTableauBord> {
  try {
    if (
      false
      // getDataMock()
    ) {
      // return fournisseurUserTableauBordMock as FournisseurUserTableauBord;
    } else {
      if (!API) {
        throw new Error("API is not provided.");
      }
      const reponse = await callApi(
        `${API}/api/coact/v1/dashboard-fournisseurs?${campagneId ? `campagne_id=${campagneId}` : ""}`,
        "GET",
        {
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRF_Token(),
        },
        "include"
      );
      return reponse;
    }
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function fetchFournisseurActionUpdateKpi(
  API: string,
  evenementId: string,
  action: "annuler" | "accepter" | "refuser"
): Promise<Contrat> {
  try {
    if (!API) {
      throw new Error("API is not provided.");
    }
    const reponse = await callApi(
      `${API}/api/coact/v1/evenements/${evenementId}/${action}`,
      "PATCH",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include"
    );

    return reponse;
  } catch (error: any) {
    throw new Error(error?.message);
  }
}
